import axios from 'redaxios';
import { useState } from 'react';

export default function App() {
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const handleAPICall = () => {
        setLoading(true);
        setMessage('');

        axios.get(`${ajaxurl}?action=react-wp-admin-ajax`)
            .then(({ data }) => {
                setMessage(`Hi ${data.name}! ${data.message}`);
            })
            .catch(() => {
               setMessage('Failed to call API, maybe you are disconnected!');
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <div>
            <h3>WP React Plugin</h3>

            <div className="react-wp-admin">
                <div>
                    <div>
                        <strong>Click the button below!</strong>
                    </div>
                    <button onClick={() => setCount(count + 1)}>Count: {count}</button>
                </div>
                <div>
                    <div>
                        <strong>Click the button below!</strong>
                    </div>
                    <button onClick={handleAPICall}>{loading ? 'Calling API ..' : 'Call API'}</button>
                    <div>{message}</div>
                </div>
            </div>

            <pre>
                <strong>Start editing:</strong> admin/react/app.jsx
            </pre>
        </div>
    )
}